import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-dmv',
  templateUrl: './service-dmv.component.html',
  styleUrls: ['./service-dmv.component.css']
})
export class ServiceDmvComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
